import { Brand } from '@ui/brand';
import { Button, Input, Link } from '@heroui/react';
import { useMask } from '@react-input/mask';
import { SubmitHandler, useForm } from 'react-hook-form';
import { maskConfig } from '@shared/const/mask.ts';
import { useLogin } from '../../entites/authorization';
import { usePhoneResolver } from '../../entites/authorization';

type Form = {
  phone: string;
};

export const PhoneForm = ({
  onSuccess,
}: {
  onSuccess: (phone: string) => void;
}) => {
  const { trigger, isMutating } = useLogin();
  const resolver = usePhoneResolver();
  const inputRef = useMask(maskConfig);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<Form>({ resolver });

  const onSubmit: SubmitHandler<Form> = async ({ phone }) => {
    trigger({ phone })
      .then(() => onSuccess(phone))
      .catch(() => {});
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="mt-12 flex flex-col items-center"
    >
      <div className="h-12">
        <Brand />
      </div>

      <h1 className="font-semibold text-xl text-[#222223] mt-12">
        Авторизация
      </h1>

      <p className="mt-4 text-center text-sm text-[#60656C]">
        Войдите, чтобы оформлять заказы, сохранить адрес доставки и историю
        заказов
      </p>

      <Input
        {...register('phone')}
        ref={inputRef}
        className="mt-8"
        type="tel"
        autoFocus
        placeholder="Номер телефона"
        classNames={{
          innerWrapper: 'h-14',
        }}
        size="lg"
        labelPlacement="inside"
        onValueChange={(v) => setValue('phone', v)}
        isInvalid={!!errors.phone?.message}
        errorMessage={errors.phone?.message}
      />

      <Button
        type="submit"
        isLoading={isMutating}
        fullWidth
        color="primary"
        size="lg"
        className="mt-8"
      >
        Войти
      </Button>

      <p className="mt-6 text-center text-sm text-[#60656C]">
        Продолжая, вы соглашаетесь c{' '}
        <Link size="sm" href="/public">
          Правилами и Политикой конфиденциальности
        </Link>
      </p>
    </form>
  );
};
